import { _ as _define_property } from "@swc/helpers/_/_define_property";
export var LOCAL_PORT = {
    retailer: 3000,
    brand: 3001,
    admin: 3003,
    developers: 3004,
    d2c: 3005,
    widget: 3006,
    blog: 3007,
    "help-center": 3008,
    visitor: 3009,
    releases: 3010,
    experiments: 3011,
    goose: 3012
};
var _obj;
var SUBDOMAINS = (_obj = {}, _define_property(_obj, LOCAL_PORT.developers, "developers"), _define_property(_obj, LOCAL_PORT.blog, "blog"), _obj);
var isFriendlyName = function(spec) {
    return !!spec && spec in LOCAL_PORT;
};
export function faireBaseUrlMatcher(env, nameOrLocalhostPort) {
    var port = isFriendlyName(nameOrLocalhostPort) ? LOCAL_PORT[nameOrLocalhostPort] : nameOrLocalhostPort;
    var subdomain = !!port && SUBDOMAINS[port] || "www";
    if (env === "production") {
        return "https://".concat(subdomain, ".faire.com");
    } else if (env === "staging") {
        return "https://".concat(subdomain, ".faire-stage.com");
    } else if (env === "prerelease") {
        return "https://".concat(subdomain, ".prerelease.faire.dev");
    } else if (env === "local") {
        return "http://localhost:".concat(port);
    }
    return undefined;
}
